import type { FC } from 'react';
import React, { useEffect } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import type { WithFlagsProps } from '@confluence/flags/entry-points/withFlags.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

import { removeRevertFlag } from './helpers/storageHelper.ts';

const i18n = defineMessages({
	revertEditorFlagSuccessTitle: {
		id: 'editor-conversion.revert-editor.flag.success.title',
		defaultMessage: 'Page is reverted to legacy editor',
		description: 'Title for the flag notifying user that we successfully reverted the target page',
	},
	revertEditorFlagSuccessBody: {
		id: 'editor-conversion.revert-editor.flag.success.body',
		defaultMessage:
			'Please note, cloud editor features such as better real-time collaboration, smart links, Live Docs, and AI-powered features are not available.',
		description: 'Body for the flag notifying user that we successfully reverted the target page',
	},
});

type RevertEditorSuccessProps = WithFlagsProps & {
	flags: FlagsStateContainer;
};

export const RevertEditorSuccessComponent: FC<RevertEditorSuccessProps> = ({ flags }) => {
	useEffect(() => {
		const description = <FormattedMessage {...i18n.revertEditorFlagSuccessBody} />;

		void flags.showSuccessFlag({
			title: <FormattedMessage {...i18n.revertEditorFlagSuccessTitle} />,
			description,
			isAutoDismiss: true,
		});

		removeRevertFlag();
	}, [flags]);

	return null;
};

export const RevertEditorSuccess = withFlags(RevertEditorSuccessComponent);
